export default [{
  name: '可视化工作流平台',
  desc: '深度拓展Flowable，可视化表单在线配置',
  index: 2,//插件分类
  version: 1,// 插件唯一id
  recommend: true,//首页精选
  pay: false,//开启购买
  mode: true,//多种版本
  org: '366434565',//作者qq
  price: '1899起',
  src: '/images/m1.png?v=01',
  path: '/flow'
}, {
  name: '低代码开发平台',
  desc: '80+组件、可视化设计、可二次开发扩展',
  index: 3,
  version: 14,
  recommend: true,
  org: '516694248',
  price: '联系商务',
  src: '/images/m14.png?v=014',
  path: '/sucode'
}, {
  name: '物联网组态系统',
  desc: '数据大屏组态插件，在线设计物联网设备信息',
  index: 3,
  version: 16,
  recommend: true,
  pay: false,
  org: 'avuejs@qq.com',
  price: '联系商务',
  src: '/images/m16.png?v=16',
  path: '/scada'
}, {
  name: '资产管理系统',
  desc: '支持PC端小程序端双端操作的资产管理系统',
  index: 3,
  version: 13,
  recommend: true,
  pay: true,
  org: '3623554899',
  price: '2599',
  src: '/images/m13.png?v=013',
  path: '/dags'
}, {
  name: '可视化表单插件',
  desc: '在线设计表单，解放双手，提高开发效率',
  index: 1,
  version: 15,
  recommend: true,
  pay: false,
  org: '366434565',
  price: '999',
  src: '/images/m15.png?v=015',
  path: '/form'
}, {
  name: '支付插件',
  desc: '一键接入微信和支付宝，免去阅读繁琐文档',
  index: 1,
  version: 4,
  recommend: true,
  pay: true,
  org: '7863347',
  price: '699',
  src: '/images/m4.png?v=04',
  path: '/payment'
}, {
  name: 'Lemon管理平台',
  desc: '基于Vben框架为BladeX定制的管理后台功能',
  index: 3,
  version: 5,
  recommend: true,
  pay: true,
  org: '519576665',
  price: '699',
  src: '/images/m5.png?v=05',
  path: '/lemon'
}, {
  name: '消息插件',
  desc: '站内信在线收发与通知',
  index: 1,
  version: 3,
  recommend: true,
  pay: true,
  org: '519576665',
  price: '199',
  src: '/images/m3.png?v=03',
  path: '/message'
}, {
  name: '邮箱插件',
  desc: '支持多种邮箱配置，在线收发邮件',
  index: 1,
  version: 2,
  recommend: true,
  pay: true,
  org: '3623554899',
  price: '399',
  src: '/images/m2.png?v=02',
  path: '/email'
}, {
  name: 'BladeX基础教学视频',
  desc: '详解BladeX开发手册，剖析基础，更快入门',
  index: 4,
  version: 6,
  recommend: true,
  pay: true,
  org: '158325293',
  price: '299',
  src: '/images/m6.png?v=06',
  path: '/course/foundation'
}, {
  name: 'Websocket插件',
  desc: 'Websocket集群连接及会话管理能力',
  index: 1,
  version: 9,
  recommend: true,
  pay: true,
  org: '229661017',
  price: '499',
  src: '/images/m9.png?v=09',
  path: '/websocket'
}, {
  name: 'License授权管理',
  desc: '部署软件提供安全支撑，防止拷贝复制与篡改',
  index: 3,
  version: 10,
  recommend: true,
  pay: true,
  org: '229661017',
  price: '399',
  src: '/images/m10.png?v=010',
  path: '/license'
}, {
  name: 'CICD平台搭建',
  desc: 'BladeX分布式部署线上真实系统生产验证',
  index: 4,
  version: 12,
  recommend: true,
  pay: true,
  org: '345779856',
  price: '599',
  src: '/images/m12.png?v=012',
  path: '/cicd'
}, {
  name: 'AgileBPM平台',
  desc: '专业的BPM平台，专属技术团队支撑',
  index: 3,
  version: 97,
  recommend: true,
  org: '240602571',
  price: '联系商务',
  src: '/images/m97.png?v=097',
  path: '/agilebpm'
}, {
  name: '等待入驻',
  desc: '更多产品敬请期待',
  index: 3,
  recommend: false,
  price: '招募中',
  src: '/images/m99.png',
  path: '/waiting'
}, {
  name: '应用市场 入驻须知',
  desc: '',
  index: 98,
  hide: true,
  path: '/notice'
}, {
  name: '应用市场 FAQ',
  desc: '',
  index: 99,
  hide: true,
  path: '/faq'
}]

